const dateFormat = 'DD/MM/YYYY';
const dateTimeFormat = 'DD-MM-YYYY HH:mm';
const hourMinFormat = 'HH:mm';

export { dateFormat, dateTimeFormat, hourMinFormat };
